import ROUTES from "@constants/routing";
import LayoutDefault from "@layouts/LayoutDefault";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

const NotFoundView: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <LayoutDefault title="404">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          gap: 2,
          backgroundColor: theme.palette.background.default,
          px: 2
        }}
      >
        <Typography variant="h1" sx={{ fontSize: 72, fontWeight: 700 }}>
          404
        </Typography>
        <Typography sx={{ color: theme.palette.text.secondary, mb: 1 }}>
          {t("errors.not_found_title", "Página no encontrada")}
        </Typography>
        <Typography
          sx={{
            color: theme.palette.text.secondary,
            mb: 3,
            textAlign: "center"
          }}
        >
          {t(
            "errors.not_found_description",
            "La página que buscas no existe o ha sido movida."
          )}
        </Typography>
        <Button
          component={RouterLink}
          to={ROUTES.WELCOME}
          variant="contained"
          color="primary"
        >
          {t("errors.go_home", "Ir a la página de inicio")}
        </Button>
      </Box>
    </LayoutDefault>
  );
};

export default NotFoundView;
